<template>
  <ModalOnboarding
    :button-label="i18n(translations.onboardingModalButtonLabel)"
    :title="i18n(translations.onboardingModalTitle)"
  >
    <template #description>
      {{ i18n(translations.onboardingModalDescription) }}
    </template>
    <template #to-do>
      <FormattedMessage :definition="translations.onboardingModalToDoSection">
        <template #listOptions>
          <ul class="ml-20 list-disc">
            <li>{{ i18n(translations.onboardingModalToDoFirstOption) }}</li>
            <li>{{ i18n(translations.onboardingModalToDoSecondOption) }}</li>
          </ul>
        </template>
      </FormattedMessage>
    </template>
    <template #done>
      {{ i18n(translations.onboardingModalDoneSection) }}
    </template>
  </ModalOnboarding>
</template>

<script setup lang="ts">
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './ShippingModalOnboarding.translations'

const i18n = useI18n()
</script>
